import React, { useState, useEffect } from "react";
import useApis from "../../services/useAPI";
import { useAuth } from "../../components/AuthContext/AuthContext";
import DynamicForm from "../../stories/Forms/DynamicForm";
import { useNavigate } from "react-router-dom";
import { BoxArrowInRight, XSquare, Eye, EyeSlash } from "react-bootstrap-icons";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { mfaValidation } from "../../stories/Forms/validationSchema";

/**
 * VerifyOTP Component
 *
 * This component handles the Multi-Factor Authentication (MFA) OTP verification process.
 * Users are required to input the OTP sent to their phone or email to complete the setup.
 *
 * @returns {JSX.Element} The rendered VerifyOTP component.
 */
const VerifyOTP = ({ onSuccess }) => {
  const { callApi, serverError, resultGet, resultPost } = useApis();
  const auth = useAuth();
  const navigate = useNavigate();
  const postUrl = `/api/dashboard/add-contact/`;
  const postUrl2 = `/api/dashboard/verify-otp`;
  const [showPassword, setShowPassword] = useState(false);

  const handleMFASubmit = async (values) => {
    const data = {
      otp: values.otp,
      user_id: localStorage.getItem("user_id"),
    };

    const url = values.otp ? postUrl2 : postUrl;

    callApi(data, url, "POST", {
      Authorization: `Bearer ${auth?.accessToken}`,
      "Content-Type": "application/json",
    });
  };

  useEffect(() => {
    if (resultPost) {
      auth?.showToast(
        "Success",
        resultPost?.message,
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
      onSuccess();
      localStorage.setItem("mfa_enabled", true)
      auth.setIsNonUKNumber(resultPost.email_mfa);
    } else {
      let error = serverError
        ? serverError ||"Unable to enable MFA for this account. Please try again later."
        : "";
      if(serverError){
        auth?.showToast("Error", error, "../assets/mhc.png", <XSquare />);
      }
    }
  }, [resultGet, resultPost, serverError]);

  return (<>
    <div className="enable-mfa">
      <h4 className="fw-bold">Enable MFA</h4>
      <p className="text-muted">
        To help keep your account safe, we’re now asking all customers
        to turn on Multi-Factor Authentication (MFA).
      </p>
      <p className="text-muted">
        By adding this extra security step, your account will be even
        more protected. Simply provide your phone number, and we’ll send
        you a quick verification code to complete the setup.
      </p>
    </div>
    <Formik
      initialValues={{ otp: "" }}
      validationSchema={mfaValidation}
      onSubmit={handleMFASubmit}
    >
      {({ setFieldValue }) => (
        <Form>
          <div className="form-group my-4">
            <div className="position-relative">
              <Field name="otp">
                {({ field }) => (
                  <input
                    {...field}
                    type={showPassword ? "text" : "password"}
                    maxLength={6}
                    placeholder="Enter your OTP"
                    inputMode="numeric"
                    className="form-control"
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 6);

                      setFieldValue("otp", value);
                    }}
                  />
                )}
              </Field>

              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <Eye /> : <EyeSlash />}
              </span>
            </div>
            <div className="invalid-feedback d-block">
              <ErrorMessage name="otp" component="div" />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-green my-4 float-end"
          >
            Verify OTP
          </button>
        </Form>
      )}
    </Formik>
    </>
  );
};

export default VerifyOTP;
